import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import config from 'react-global-configuration';
import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import { MagicLine } from '@uncinc/uncinc-react-kitchen-sink';

import { MENU_NL } from '../../../config/constants';

import './style.scss';

const MainMenu = ({
  setActiveOverlayMenu,
  overlayRefs,
}) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));

  return (
    <MagicLine activeClassName="MainMenu__item--active">
      {(setInitialMagicLine, hoverMagicLine, setActiveItemInNavigation) => (
        <>
          <div className="overlay-closer overlay-closer__left" onMouseEnter={() => setActiveOverlayMenu(null)} />
          <Menu id={MENU_NL}>
            {(items) => {
              return (
                <>
                  {items.map((item, index) => {
                    if (item) {
                      const title = item.getIn(['link', 'title'], 'Untitled');
                      const url = item.getIn(['link', 'url'], '');
                      const active = item.getIn(['link', 'url']) === currentPage;
                      const MainMenuItemClassnames = c(
                        'MainMenu__item',
                        `MainMenu__index__${index}`,
                        {
                          'MainMenu__item--active': active,
                        },
                      );

                      if (active) {
                        setActiveItemInNavigation(true);
                      }

                      return (
                        <div key={title} className={MainMenuItemClassnames}
                          onMouseEnter={(e) => {
                            hoverMagicLine(e);
                            setActiveOverlayMenu(index, overlayRefs);
                          }}
                          onMouseLeave={() => {
                            setInitialMagicLine();
                          }}
                        >
                          <CoreLink
                            className="MainMenu__item__link"
                            href={url}
                            onClick={() => setActiveOverlayMenu(null)}
                          >
                            <span className="MainMenu__item__title">{title}</span>
                          </CoreLink>
                        </div>
                      );
                    }
                  })}
                </>
              );
            }}
          </Menu>
          <div className="overlay-closer overlay-closer__right" onMouseEnter={() => setActiveOverlayMenu(null)} />
        </>
      )}
    </MagicLine>
  );
};

export default MainMenu;
